/**
 * Formats a phone number as (XXX) XXX-XXXX
 * @param {string} value - The phone number value (can be formatted or unformatted)
 * @returns {string} - Formatted phone number as (XXX) XXX-XXXX
 */
export const formatPhoneNumber = (value) => {
  if (!value) return "";
  
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, "");
  
  // Limit to 10 digits (US phone number)
  const limitedDigits = digits.slice(0, 10);
  
  // Format based on length
  if (limitedDigits.length === 0) return "";
  if (limitedDigits.length <= 3) return `(${limitedDigits}`;
  if (limitedDigits.length <= 6) {
    return `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(3)}`;
  }
  return `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(3, 6)}-${limitedDigits.slice(6)}`;
};

/**
 * Removes formatting from a phone number, returning only digits
 * @param {string} value - The formatted phone number
 * @returns {string} - Unformatted phone number (digits only)
 */
export const unformatPhoneNumber = (value) => {
  if (!value) return "";
  return value.replace(/\D/g, "");
};

/**
 * Formats phone number input as user types, handling backspace/delete properly
 * @param {string} value - Current input value
 * @param {string} previousValue - Previous input value (for detecting deletions)
 * @returns {string} - Formatted phone number
 */
export const formatPhoneInput = (value, previousValue = "") => {
  // If value is being deleted (getting shorter), allow deletion
  const digits = value.replace(/\D/g, "");
  const prevDigits = previousValue.replace(/\D/g, "");
  
  // If deleting, format the remaining digits
  if (digits.length < prevDigits.length) {
    return formatPhoneNumber(digits);
  }
  
  // If adding, format the new digits
  return formatPhoneNumber(digits);
};

